export function createExportExcelGridWorker() {
  if (typeof Worker !== 'undefined') {
    const worker = new Worker(
      new URL('../worker/export-excel-grid.worker', import.meta.url),
    );
    return worker;
  }
  return {};
}

export function createExportPdfGridWorker() {
  if (typeof Worker !== 'undefined') {
    const worker = new Worker(
      new URL('../worker/export-pdf-grid.worker', import.meta.url),
    );
    return worker;
  }
  return {};
}

export function createZipFileWorker() {
  if (typeof Worker !== 'undefined') {
    const worker = new Worker(new URL('../worker/zip-files.worker', import.meta.url));
    return worker;
  }
  return {};
}

export function createDeleteFileWorker() {
  if (typeof Worker !== 'undefined') {
    const worker = new Worker(
      new URL('../worker/delete-files.worker', import.meta.url),
    );
    return worker;
  }
  return {};
}
